import React from 'react';
import Subtopics from './Subtopics';
import { Container } from "react-bootstrap";
import {
    Switch,
    Route,
    Link,
    useRouteMatch
  } from "react-router-dom";

function MachineAssembly(props) {
    let { path, url } = useRouteMatch();
    return (
        <div>
            <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', maxWidth: "100vw"}}>
                {/* <SectionTitle title={props.topicId}/> */}
            <div style={{display: 'flex', flexDirection: 'row'}}> 
            <div style={{marginTop: '10px', marginRight: '0px', marginLeft: '5px',border: '3px', padding:'40px', paddingRight: '50px', borderStyle:'solid', borderColor:'grey', paddingLeft: '20px', whiteSpace:'nowrap'}}>
                <h2>Machine Assembly</h2>
                <li>
                    <Link to={`${url}/welding`}>Welding</Link>
                </li>
                <li>
                    <Link to={`${url}/weldinggases`}>Welding Gases</Link>
                </li>
                <li>
                    <Link to={`${url}/brazing`}>Brazing</Link>
                </li>
                <li>
                    <Link to={`${url}/adhesives`}>Adhesives</Link>
                </li>
                <li>
                    <Link to={`${url}/fasteners`}>Fasteners</Link>
                </li>
                <li>
                    <Link to={`${url}/rivets`}>Rivets</Link>
                </li>
                <li>
                    <Link to={`${url}/shrinkfitting`}>Shrink Fitting</Link>
                </li>            
                </div>
                
            <Container>
                <Switch>
                    <Route exact path={path}>
                    <h3>Please select a sub-topic.</h3>
                    </Route>
                    <Route path={`${path}/:topicId`}>
                        <Subtopics />
                    </Route>
                </Switch>
            </Container>
         
                    </div>
            </div>
        </div>
    );
};

export default MachineAssembly; 